<template>
  <span v-if="!decisionMade" />
  <TestA v-else-if="showExperienceA || showExperienceB" />
</template>

<script>
import Cookies from 'js-cookie';
import { identify, track } from '../../analytics/events';
import { deviceOS } from '../../utils/deviceType';
import TestA from '../../choice-views/Disclaimer/desktop.vue';

export default {
  name: 'MMChoiceProvider',
  testExperienceNames: [
    'MYMOVE CHOICE Desktop Disclaimer A',
    'Choice Desktop',
    'MYMOVE CHOICE Desktop VerifyInfo WideView',
  ],
  testPlacement: 'Disclaimer',
  components: {
    TestA,
  },
  data() {
    return {
      amp_data: [],
      decisionMade: false,
      showExperienceA: false,
      showExperienceB: false,
      showVerifyInfoWideView: false,
    };
  },
  computed: {
    flagAmpersendEnabled() {
      return this.$store.get('flagAmpersendEnabled');
    },
  },
  beforeRouteEnter(to, from, next) {
    /* RESET COA BEHAVIOR */
    const allowedReEntry = [
      'address-info',
      'contact-info',
      'additional-services',
      'verify-info-read',
      'verify-info-edit',
      'identity-check',
      'cmra',
      'residential-business',
      'old-unique-zip',
      'fatal-error',
    ];

    next((vm) => {
      if ((!allowedReEntry.includes(from.name) && !sessionStorage.getItem('newSession')) || Cookies.get('coa_complete')) {
        vm.$deleteSession();
        vm.$coa.reset();
        Cookies.remove('coa');
        Cookies.remove('coa_complete');
        vm.$resetAppState();
      }
      vm.$store.commit('ENABLE_LOADER');
    });
  },
  async mounted() {
    sessionStorage.setItem('newSession', true);
    let identifyApp = false;
    if (!this.$coa.coaUUID) {
      const { utm_medium: utmMedium } = this.$route.query;
      await this.$coa.coaCreate(utmMedium || '');
      this.$setSession(this.$coa.coaUUID, this.$coa.orderId);

      if (this.flagAmpersendEnabled) {
        const mgoUserAgent = deviceOS();
        this.$amp.setAnonymousID(this.$coa.coaUUID);
        await this.$amp.identify({
          isVerified: false,
          mgoDeviceType: 'DESKTOP',
          mgoUserAgent,
        });
        identifyApp = true;
      }

      identify(this.$coa.coaUUID);
      track('CoaCreated', {
        uuid: this.$coa.coaUUID,
        visitId: this.$coa.visitId,
      });
    }
    const splits = this.flagAmpersendEnabled ? await this.$amp.getUnimpressedExperiences() : [];
    if (splits?.length) {
      const name = splits.map((exp) => exp.name);
      const agentId = splits.map((exp) => exp.agentId);
      this.showExperienceA = name.includes(this.$options.testExperienceNames[0])
      || name.includes(this.$options.testExperienceNames[2]);
      this.showExperienceB = name.includes(this.$options.testExperienceNames[1]);
      this.showVerifyInfoWideView = name.includes(this.$options.testExperienceNames[2]);

      if (agentId) {
        track('DecisionMade', {
          agentId,
          name,
        });
      }
    }

    if (identifyApp) {
      // Note: This property can't be update in the initial call to '$amp.identify'
      // since it depends on a call to response from '$amp.getUnimpressedExperiences'
      // which requires an initial call to '$amp.identify'. Therefore this property
      // 'mgoApplication' should preferably be used in AMP post global experiences
      await this.$amp.identify({
        mgoApplication: !this.showExperienceA && !this.showExperienceB ? 'simplify' : 'choice',
      });
    }

    this.decisionMade = true;
    this.$store.commit('DISABLE_LOADER');
    this.amp_data = [...this.amp_data, ...splits];
    sessionStorage.setItem('amp_data', JSON.stringify(this.amp_data));
    sessionStorage.setItem('showChoiceExperience', this.showExperienceA || this.showExperienceB);
    sessionStorage.setItem('showSimplifyExperience', !(this.showExperienceA || this.showExperienceB));
    sessionStorage.setItem('showVerifyInfoWideView', this.showVerifyInfoWideView);
    if (!this.showExperienceA && !this.showExperienceB) {
      this.$router.push({ name: 'address-info', query: this.$route.query });
    }
  },
  methods: {
    findTestExperience({ templates: [template] }) {
      return template.properties.name === this.$options.testPlacement;
    },
  },
};
</script>
